import { Add } from '@mui/icons-material';
import { ContainedButton, ContainedButtonProps } from '@shared/components';
import { forwardRef } from 'react';

const AddButton: React.FC<ContainedButtonProps<'button'>> = forwardRef(
  (
    {
      sx = { whiteSpace: 'nowrap' },
      color = 'secondary',
      startIcon = <Add />,
      size = 'small',
      ...rest
    },
    ref: ContainedButtonProps<'button'>['ref']
  ) => (
    <ContainedButton sx={sx} color={color} startIcon={startIcon} size={size} ref={ref} {...rest} />
  )
);

export default AddButton;






